import { redirect, error } from "@sveltejs/kit";
// import matter from "gray-matter";
// import * as matter from "gray-matter";
import { readingTime } from "reading-time-estimator";

import { m } from "$lib/paraglide/messages.js";
import {
  // setLocale,
  baseLocale,
  // getLocale,
  // locales
  // localizeHref
} from "$lib/paraglide/runtime";
import { extractFrontmatter } from "$lib/utils/index.js";

const modules = import.meta.glob(["$posts/*.md", "!$posts/*.bak", "!$posts/*.local.md"], {
  query: "?raw",
  import: "default",
  eager: true,
});

/** @type {import('./$types').PageLoad} */
export const load = async ({ params, data }) => {
  const { locale } = data;
  const requestedSlug = params.slug;
  // const currentLang = getLocale();

  const modules = import.meta.glob(["$posts/*.md", "!$posts/*.bak", "!$posts/*.local.md"], {
    query: "?raw",
    import: "default",
  });

  const map = {}; // { canonical: { en: 'hello', tr: 'merhaba' } }
  let match = null;

  for (const [vitePath, loader] of Object.entries(modules)) {
    const raw = await loader();
    const fm = extractFrontmatter(raw);
    // const { data: fm } = matter(raw); // data = frontmatter
    const lang = vitePath.match(/\.(\w{2})\.md$/)?.[1];

    if (!lang || !fm.canonical) continue;

    // map’i doldur
    if (!map[fm.canonical]) map[fm.canonical] = {};
    map[fm.canonical][lang] = fm.slug;

    // eşleşme var mı?
    // Not: canonical ve slug birden fazla dilde ayni olabilir (ör. core-web-vitals).
    // Bu yuzden mevcut locale ile birebir eslesen dosyayi tercih ediyoruz; aksi halde
    // dongudeki son eslesme kazanir ve yanlis dil secilip sonsuz redirect olusur.
    if (fm.canonical === requestedSlug || fm.slug === requestedSlug) {
      match = { vitePath, loader, fm, lang };
      // if (!match || lang === locale) {
      //   match = { vitePath, loader, fm, lang };
      // }
    }
  }

  if (!match) throw error(404, "Yazı bulunamadı");

  // 2) dil uyuşmazsa doğru slug’a yönlendir
  // trailingSlash="always" oldugu icin hedef URL'ler sonunda "/" ile bitmeli,
  // aksi halde SvelteKit 308 ile slash ekler ve 302<->308 dongusu olusur.
  if (match.lang !== locale) {
    const correctSlug = map[match.fm.canonical][locale];
    if (!correctSlug) throw error(404, m.no_translation_found());
    if (locale === baseLocale) {
      throw redirect(302, `/posts/${correctSlug}/`);
    } else {
      if (locale === "tr") {
        throw redirect(302, `/tr/makaleler/${correctSlug}/`);
      }
    }
  }

  try {
    const markdownPost = await import(`$posts/${requestedSlug}.${locale}.md`);
    if (markdownPost.metadata.published) {
      markdownPost.metadata.timeToRead = readingTime(markdownPost.metadata.plaintext, 238, locale);
      return {
        metadata: markdownPost.metadata,
        post: markdownPost.default,
      };
    } else {
      // throw error(404, `The post could not be published yet!`);
      throw error(404, `Could not find ${requestedSlug}`);
    }
  } catch (e) {
    console.error(e);
    // if (e) throw e;
    throw error(404, `Could not find ${requestedSlug}`);
  }
};

const getPostEntries = async ({ modules }) => {
  const canonicalMap = {}; // canonical -> {en: slug, tr: slug}

  for (const [filePath, source] of Object.entries(modules)) {
    const meta = extractFrontmatter(source);
    // console.log("### META", meta);
    // console.log("### META SOURCE", source);

    // Skip unpublished content
    if (!meta.published) continue;

    // const meta = mod.metadata;
    // if (!meta?.published) continue;

    const locale = filePath.match(/\.(\w{2})\.md$/)?.[1] || baseLocale;
    const baseSlug = filePath
      .split("/")
      .pop()
      .replace(/\.(\w{2})\.md$/, "");
    const slug = meta.slug || baseSlug;

    if (!canonicalMap[meta.canonical]) canonicalMap[meta.canonical] = {};
    canonicalMap[meta.canonical][locale] = { locale, slug };
  }

  console.log("canonicalMap", canonicalMap);

  /* Sadece default locale’deki slug’ları döndür */
  const slugs = [];
  const processed = new Set();

  for (const translations of Object.values(canonicalMap)) {
    const defaultSlug = translations[baseLocale];
    if (!defaultSlug || processed.has(defaultSlug)) continue;
    processed.add(defaultSlug);

    for (const trans of Object.values(translations)) {
      // console.log("trans", trans);
      slugs.push(trans);
    }

    // slugs.push({ locale: translations, slug: defaultSlug });
  }

  console.log("processed", processed);
  console.log("slugs", slugs);

  return slugs;
};

export function entries() {
  const slugs = getPostEntries({ modules });
  // console.log("slugs", slugs);
  return slugs;
  // return [{ slug: "welcome" }];
}

// TODO: fix prerender true
// export const prerender = "auto";
export const prerender = true;
